import { render, staticRenderFns } from "./b-report-run-status.vue?vue&type=template&id=447d22ee&scoped=true"
import script from "./b-report-run-status.vue?vue&type=script&lang=js"
export * from "./b-report-run-status.vue?vue&type=script&lang=js"
import style0 from "./b-report-run-status.vue?vue&type=style&index=0&id=447d22ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d22ee",
  null
  
)

export default component.exports